import { render, staticRenderFns } from "./TravellerScanHistory.vue?vue&type=template&id=a0fc5df0&scoped=true&"
import script from "./TravellerScanHistory.vue?vue&type=script&lang=js&"
export * from "./TravellerScanHistory.vue?vue&type=script&lang=js&"
import style0 from "./TravellerScanHistory.vue?vue&type=style&index=0&id=a0fc5df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fc5df0",
  null
  
)

export default component.exports